import TableBody from './TableBody'
import TableHeader from './TableHeader'
import { TableContainer } from './styles'
import { ColumnProps, SortDirection } from './types'

interface TableProps {
  columns: ColumnProps[]
  data: any
  externalLink?: ExternalLinkProps | null
  className?: string
  sortColumn?: string
  sortDirection?: SortDirection
  onSort?: (sortKey: string) => void
}

interface ExternalLinkProps {
  label: string
  url: string
}

const Table = ({
  columns,
  data,
  className,
  sortColumn,
  sortDirection,
  onSort
}: TableProps) => {
  return (
    <TableContainer className={className}>
      <TableHeader
        columns={columns}
        sortColumn={sortColumn}
        sortDirection={sortDirection}
        onSort={onSort}
      />
      <TableBody columns={columns} data={data} />
    </TableContainer>
  )
}

export { Table }
